import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@ace-clublabs/shared-component-library';
import App from './App';
import { initializeLogger } from './services/logger';

initializeLogger();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider>
      <BrowserRouter basename="/enterprise/links-alp">
        <App />
      </BrowserRouter>
    </ThemeProvider>
  </React.StrictMode>
);
